import ActionIconGroup from "../../../../ActionIconGroup";
import { useChatListActionsBar } from "../../../../hooks/useChatListActionsBar";
import { memo } from 'react';
import useCustomChatListAction from "../../../../hooks/useCustomChatListAction";
import { ErrorActionsBar } from "../Actions/Error";
import { jsx as _jsx } from "react/jsx-runtime";
export var AssistantActionsBar = /*#__PURE__*/memo(function (_ref) {
  var text = _ref.text,
    id = _ref.id,
    onActionClick = _ref.onActionClick,
    error = _ref.error,
    actionsProps = _ref.actionsProps;
  var _useChatListActionsBa = useChatListActionsBar(text),
    regenerate = _useChatListActionsBa.regenerate,
    edit = _useChatListActionsBa.edit,
    copy = _useChatListActionsBa.copy,
    divider = _useChatListActionsBa.divider,
    del = _useChatListActionsBa.del;
  var _useCustomChatListAct = useCustomChatListAction({
      dropdownMenu: [edit, copy, regenerate,
      // divider,
      // TODO: need a translate
      divider, del],
      items: [regenerate, copy],
      actionsProps: actionsProps
    }),
    dropdownMenu = _useCustomChatListAct.dropdownMenu,
    items = _useCustomChatListAct.items;
  if (id === 'default') return;
  if (error) return /*#__PURE__*/_jsx(ErrorActionsBar, {
    onActionClick: onActionClick,
    text: text
  });
  return /*#__PURE__*/_jsx(ActionIconGroup, {
    dropdownMenu: dropdownMenu,
    items: items,
    onActionClick: onActionClick,
    type: "ghost"
  });
});